import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tile from './tile';
import { NoResults } from '../catalog_no_result/no_results';
import { CatalogSorting } from '../catalog_sorting/catalog_sorting';
import { TFormOptions } from '../_component_types/form/form_options';
import shippingFeesStore from '../../stores/shipping_fees_store';
import HttpRequestStore from '../../stores/http_request_store';
import ProductBatchStocksStore from '../../stores/product_batch_stocks/product_batch_stocks_store';
import ShippingFees from './tile/shipping_fees';
import { allowShippingQuoteOnStore } from '../../../_views/shipping_quote/common';

const { store, staticImagesUrl } = TYROOLA.globals;

class CatalogProducts extends Component {
  constructor() {
    super();
    this.state = {
      shippingData: shippingFeesStore.getState(),
      shippingDataLength: shippingFeesStore.getState().length,
      httpRequestStore: HttpRequestStore.getState(),
      productBatchStocksState: ProductBatchStocksStore.getState(),
    };
  }

  componentDidMount() {
    if (allowShippingQuoteOnStore(store)) {
      shippingFeesStore.addListener(() => this._getShippingStore());
      HttpRequestStore.addListener(() => this._getHttpRequestStore());
      ProductBatchStocksStore.addListener(() => this._getProductBatchStocksStore());
    }

    if (location.href.indexOf('disableDriverReviews=1') === -1) {
      const catalogAdsContainer = document.querySelector('#catalog-revamp-ads-container');
      if (!catalogAdsContainer) {
        let counter = 1;
        let clearIntervalFn3 = setInterval(() => {
          const promotionProductsLength = TYROOLA.initialFluxStates.promotions.length;
          const isPromoDrAvailable = promotionProductsLength
            ? document.querySelectorAll('#catalog-promotions-container-revamp .driverreviews-widget')
            : document.querySelectorAll('.driverreviews-widget');
          const isDrAvailable = document.querySelectorAll('.driverreviews-widget');
          if ((window.driverreviews && isPromoDrAvailable.length && isDrAvailable.length) || counter >= 200) {
            clearInterval(clearIntervalFn3);
            window.driverreviews && window.driverreviews.refreshWidgets();
          }
          counter += 1;
        }, 50);
      }
    }
  }

  componentWillUnmount() {
    shippingFeesStore.addListener(() => this._getShippingStore());
    HttpRequestStore.addListener(() => this._getHttpRequestStore());
    ProductBatchStocksStore.addListener(() => this._getProductBatchStocksStore());
  }

  _getShippingStore() {
    this.setState({
      shippingData: shippingFeesStore.getState(),
      shippingDataLength: shippingFeesStore.getState().length,
    });
  }

  _getHttpRequestStore() {
    this.setState({
      httpRequestStore: HttpRequestStore.getState(),
    });
  }

  _getProductBatchStocksStore() {
    this.setState({
      productBatchStocksState: ProductBatchStocksStore.getState(),
    });
  }

  render() {
    const {
      products,
      staticUrl,
      onNotifyMeClick,
      sorting,
      sortingOptions,
      onSortingChange,
      metroArea,
      showShowDetailsButton,
      onProductClick,
      currencyIsoCode,
      onOpenFSFClick,
      onClickAddToCart,
      productType,
      onAlternativeProductStockClick,
      buyerAssistUrl,
    } = this.props;

    const { shippingData, shippingDataLength, httpRequestStore, productBatchStocksState } = this.state;

    if (this.props.products.length) {
      return (
        <div className="catalog-revamp-products__container">
          <CatalogSorting
            sorting={sorting}
            sortingOptions={sortingOptions}
            onChange={onSortingChange}
            productType={productType}
          />
          <div className="catalog-products">
            {products.map((product, idx) => {
              return (
                <div className="catalog-products__product catalog-product" key={product.sku}>
                  <Tile
                    index={idx}
                    data={Object.assign({}, product, {
                      stock: product.stock || 0,
                      priceRrp: product.priceRrp || '',
                      freeShipping: product.freeShipping || false,
                      showFreeFitting: product.showFreeFitting || false,
                      shippingTime: product.shippingTime || '',
                      onNotifyMeClick: () => onNotifyMeClick(product.sku),
                      onOpenFSFClick: () => onOpenFSFClick(product.sku),
                      onClickAddToCart: () => onClickAddToCart(product),
                      productType: productType,
                      staticUrl: staticUrl,
                      staticImagesUrl: staticImagesUrl,
                      metroArea: metroArea,
                      showShowDetailsButton: showShowDetailsButton,
                      fittingPromotion: product.fittingPromotion,
                      catalogPromotion: false,
                      priceDiscount: product.priceDiscount,
                      customerAverageRatings: product.customerAverageRatings,
                    })}
                    shippingFees={
                      <ShippingFees
                        productSku={product.sku}
                        productType={productType}
                        promotion={product.fittingPromotion}
                        stock={product.stock}
                        shippingData={shippingData}
                        currencyIsoCode={currencyIsoCode}
                        staticImagesUrl={staticImagesUrl}
                      />
                    }
                    shippingData={shippingData}
                    shippingDataHasValue={shippingDataLength > 0}
                    onProductClick={onProductClick}
                    currencyIsoCode={currencyIsoCode}
                    onSeeHowItWorksClick={this.props.onSeeHowItWorksClick}
                    httpRequestShippingFees={httpRequestStore.shipping_fees}
                    productBatchStocks={getProductBatchStock(product.sku, productBatchStocksState)}
                    httpRequestProductBatchStocks={httpRequestStore.product_batch_stocks}
                    onAlternativeProductStockClick={onAlternativeProductStockClick}
                    buyerAssistUrl={buyerAssistUrl && buyerAssistUrl.replace('{spinach-id}', product.sku)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return getNoResultsPage(this.props);
    }
  }
}

function getProductBatchStock(productSku, productBatchStocksState) {
  let stocks = productBatchStocksState.productBatchStocks;
  let alternativeStocks = null;
  stocks.map((item) => {
    if (item.id.value !== productSku) return null;

    alternativeStocks = item;
  });

  return alternativeStocks;
}

function getNoResultsPage({ suggestion, onImproveClick, onRemoveClick }) {
  return <NoResults suggestions={suggestion} onImproveClick={onImproveClick} onRemoveClick={onRemoveClick} />;
}

CatalogProducts.propTypes = {
  products: PropTypes.array.isRequired,
  staticUrl: PropTypes.string.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  sorting: PropTypes.string.isRequired,
  onNotifyMeClick: PropTypes.func.isRequired,
  onOpenFSFClick: PropTypes.func.isRequired,
  onClickAddToCart: PropTypes.func.isRequired,
  onImproveClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onSortingChange: PropTypes.func.isRequired,
  onProductClick: PropTypes.func.isRequired,
  onSeeHowItWorksClick: PropTypes.func.isRequired,
  sortingOptions: TFormOptions.isRequired,
  metroArea: PropTypes.string,
  showShowDetailsButton: PropTypes.bool,
  productType: PropTypes.string,
  onAlternativeProductStockClick: PropTypes.func.isRequired,
  buyerAssistUrl: PropTypes.string,
};

export default CatalogProducts;
